module.exports = __webpack_public_path__ + "media/images/riders/small/JULIE_BRESSET-b3f7b3f08f7040efa4f28e1b34ca4371.png";